import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Method() {
  return <section className="bg-cream py-16 sm:py-24" aria-labelledby="method-title" data-id="element-93" data-mp="c283j80a2cyr">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16" data-id="element-94" data-mp="c05g8vqiexxq">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.55
      }} className="order-2 overflow-hidden rounded-[2rem] border-8 border-white shadow-soft lg:order-1" data-id="element-95" data-mp="gyp451onyjsq">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/2594dcb4-7a6f-4700-9c5f-2355aa8223cd.jpg" alt="Profesora del Método Maestro Amigurumi sosteniendo un muñeco tejido a mano" className="h-full w-full object-cover" data-id="element-96" data-mp="3u7uw0oyny5kl" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.55
      }} className="order-1 lg:order-2" data-id="element-97" data-mp="31oxn9sm3gvgz">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-98" data-mp="fo20w71prlgn">
            La revelación
          </span>
          <h2 id="method-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-[2.6rem]" data-id="element-99" data-mp="6ox2d0q5js4h">
            Presentamos el Método Maestro Amigurumi
          </h2>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-muted" data-id="element-100" data-mp="1s6n2fm690k4">
            <p data-id="element-101" data-mp="3sweulhqtlq1z">
              Destilé años de experiencia en una guía digital práctica que elimina la confusión.
              Este no es solo “un curso de tejido”: es el mapa exacto para que tus manos hagan
              realidad cualquier diseño que imagines.
            </p>
            <p data-id="element-102" data-mp="1n4huhunuaomf">
              Aprendé a tu ritmo, desde la comodidad de tu casa, y convertí el tejido en tu terapia
              diaria y, por qué no, en tu nuevo emprendimiento.
            </p>
          </div>
        </motion.div>
      </div>

      <motion.div id="oferta" initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.6
    }} className="mx-auto mt-16 max-w-3xl scroll-mt-24 px-5 sm:mt-24" data-id="element-103" data-mp="3legpdpfo914k">
        <div className="rounded-3xl bg-ink p-8 shadow-2xl sm:p-12" data-id="element-104" data-mp="34wks6t4lh8c">
          <div className="text-center" data-id="element-105" data-mp="84sr4cpapkr2">
            <h3 className="font-display text-2xl font-black text-cream sm:text-3xl" data-id="element-106" data-mp="83pz21g8lc9k">
              Te llevás todo esto por $11.990:
            </h3>
          </div>
          
          <ul className="mx-auto mt-8 max-w-lg space-y-4" data-id="element-107" data-mp="3v8ytgvp02yow">
            {['El Método Maestro Amigurumi completo', 'BONO 1: Diccionario Universal de Puntos', 'BONO 2: Guía de Materiales Recomendados', 'BONO 3: Los 5 Patrones de Práctica', 'Patrones listos para empezar a tejer'].map(item => <li key={item} className="flex items-center gap-4 text-lg font-semibold text-cream/90" data-id="element-108" data-mp="27c94tfyoocub">
                <CheckCircle2Icon className="h-6 w-6 shrink-0 text-terracotta-light" aria-hidden="true" data-id="element-109" data-mp="2lbha8qlfwh6y" />
                <span data-id="element-110" data-mp="2ge8oyh4zvx1h">{item}</span>
              </li>)}
          </ul>
          
          <div className="mx-auto mt-10 max-w-xl" data-id="element-111" data-mp="1sowi3nx5412c">
            <CtaButton data-id="element-112" data-mp="1np1npae5otcj" />
            <p className="mt-5 flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-cream/60" data-id="element-113" data-mp="1nptbw05fboss">
              <ShieldCheckIcon className="h-5 w-5 text-sage" data-id="element-114" data-mp="22fioqsmvph8w" />
              Pagá seguro con Mercado Pago
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}